var _classCallCheck = require("/newdisk/jisung/JS_DataStructure_Visualization/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/newdisk/jisung/JS_DataStructure_Visualization/node_modules/@babel/runtime/helpers/createClass");

/**
 * @classdesc Express list element.<br>
 * @protected
 */
var ListNode =
/*#__PURE__*/
function () {
  "use strict";

  /**
   * Create node of list.
   * @constructor
   * @protected
   * @param {*} data - the data of node. 
   * @param {*} prev - point the front node of this node.
   * @param {*} next - point the next node of thie node.
   */
  function ListNode() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var prev = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var next = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    _classCallCheck(this, ListNode);

    /**
     * data variable
     * @private
     * @type {*}
     */
    this._data = data;
    /**
     * front node
     * @private
     * @type {Node}
     */

    this._prev = prev;
    /**
     * next node
     * @private
     * @type {Node}
     */

    this._next = next;
  }
  /**
   * Get the data of Node.
   * @return {*} The data of Node.
   */


  _createClass(ListNode, [{
    key: "getData",
    value: function getData() {
      return this._data;
    }
    /**
     * Set the data of Node.
     * public method for change data of node in list.
     * @param {*} data - The data of Node.
     */

  }, {
    key: "setData",
    value: function setData(data) {
      this._data = data;
    }
    /**
     * Get the front node.
     * @return {Node} The front node.
     */

  }, {
    key: "getPrev",
    value: function getPrev() {
      return this._prev;
    }
    /**
     * Set the front node.
     * @protected
     * @param {Node} prev - The front node.
     */

  }, {
    key: "setPrev",
    value: function setPrev(prev) {
      this._prev = prev;
    }
    /**
     * Get the next node.
     * @return {Node} The Next node.
     */

  }, {
    key: "getNext",
    value: function getNext() {
      return this._next;
    }
    /**
     * Set the next node.
     * @protected
     * @param {Node} next - The next node.
     */

  }, {
    key: "setNext",
    value: function setNext(next) {
      this._next = next;
    }
  }]);

  return ListNode;
}();

module.exports = ListNode;